import { IKeyValue, IKeyValueObj } from '@fareye/types'
import { Flex } from '@fareye/ui'
import {
  del,
  get,
  getQueryParams,
  idInUrlIntegrator,
  isEmpty,
  post,
  responseParser
} from '@fareye/utils'
import Axios from 'axios'
import React from 'react'
import { ISearchES } from '../../utility/types'
import ListSearchFIlters from './containers/ListSearchFIlters'
import SearchFavourite from './containers/SearchFavourite'
import AddFav from './components/AddFav'
import { GlobalSearchChildWrapper } from '../../style/styled'
import { headers } from '../../config/constants'

export const SearchFilterWrapper = ({
  apiFav,
  pageId,
  search: globalSearch,
  apiFilter,
  setSearch,
  startDate,
  endDate,
  children,
  style = {},
  customKeyMapping,
  summaryKeys,
  showTimezone = false,
  showIcon
}: ISearchES) => {
  if (apiFav.apiURL.includes('records.json')) {
    console.warn(
      'JSON STORE need to be updated for globalsearch url "/json_store/records.json" is wrong needs to be "/api/v1/records'
    )
  }
  const [showAddFavModal, setShowAddFavModal] = React.useState<boolean>(false)
  const [favName, setFavName] = React.useState<string>('')
  const [favList, setFavList] = React.useState<IKeyValue<string>[] | []>([])
  const [selectedFilter, setSelectedFilter] = React.useState(globalSearch)
  const [flagged, setFlagged] = React.useState(false)

  const closest = (arr: IKeyValue<string>[], searchValue: string) => {
    return arr.sort((a: IKeyValue<string>, b: IKeyValue<string>) => {
      const diff1 = a.value.toLowerCase().includes(searchValue.toLowerCase())
        ? searchValue.length / a.value.length
        : 0
      const diff2 = b.value.toLowerCase().includes(searchValue.toLowerCase())
        ? searchValue.length / b.value.length
        : 0
      return diff1 < diff2 ? 1 : -1
    })
  }
  const s1 = Axios.CancelToken.source()
  const s2 = Axios.CancelToken.source()
  const s3 = Axios.CancelToken.source()

  React.useEffect(() => {
    if (apiFav) {
      fetchFavourites()
    }
    return () => {
      s1.cancel
      s2.cancel
      s3.cancel
    }
  }, [])

  async function fetchFavourites() {
    try {
      const query = getQueryParams(apiFav.queryParams)
      const { data } = await get(`${apiFav.apiURL}?${query}`, s1.token)
      setFavList(data.configs)
    } catch (ex:any) {
      console.error('Error Fetching Favourites.')
    }
  }
  async function saveFavorite() {
    setShowAddFavModal(false)
    try {
      const query = {
        record: {
          ...apiFav.queryParams,
          name: favName,
          data: { filters: selectedFilter, flagged }
        }
      }
      const { data } = await post(apiFav.apiURL, query, s2.token)
      if (data) {
        setFlagged(false)
        fetchFavourites()
        setFavName('')
      }
    } catch (ex:any) {
      console.error('Error Fetching Favourites.')
    }
  }

  async function deleteFavourite(id: number) {
    try {
      if (window.confirm('Are You Sure you want to Delete?')) {
        const { data } = responseParser(
          await del(`${idInUrlIntegrator(apiFav.apiURL, id)}`, s3.token)
        )
        if (data.deleted) {
          fetchFavourites()
        }
      }
    } catch (err:any) {
      console.error('Error Deleting Favourite.')
    }
  }
  // fav data filters is any because of API response
  function selectFav(item: IKeyValueObj<string | number | any>) {
    item.data.filters && setSelectedFilter(item.data.filters)
    sessionStorage.setItem(
      'globalSearch',
      JSON.stringify({ selectedFilter, pageId })
    )
    setSearch(item.data.filters)
  }
  return (
    <Flex column style={{ width: '100%', ...style.listWrapper }}>
      <GlobalSearchChildWrapper style={{ width: '100%', ...style.wrapper }}>
        {children}
        <SearchFavourite
          pageId={pageId}
          closest={closest}
          summaryKeys={summaryKeys}
          endDate={endDate}
          favList={favList}
          apiFilter={apiFilter}
          selectFav={selectFav}
          setSearch={setSearch}
          startDate={startDate}
          selectedFilter={selectedFilter}
          deleteFavourite={deleteFavourite}
          customKeyMapping={customKeyMapping}
          setSelectedFilter={setSelectedFilter}
          setShowAddFavModal={setShowAddFavModal}
          showTimezone={showTimezone}
          showIcon={showIcon}
        />
      </GlobalSearchChildWrapper>
      {!isEmpty(selectedFilter) ? (
        <ListSearchFIlters
          setSearch={setSearch}
          pageId={pageId}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        />
      ) : null}
      {apiFav && (
        <AddFav
          favName={favName}
          flagged={flagged}
          setFlagged={setFlagged}
          setFavName={setFavName}
          saveFavorite={saveFavorite}
          selectedFilter={selectedFilter}
          showAddFavModal={showAddFavModal}
          setShowAddFavModal={setShowAddFavModal}
        />
      )}
    </Flex>
  )
}
